import React from "react"
import { FormControl } from "react-bootstrap"
import axios from "axios"

const Individual = props => {
    return <div className={props.show ? "row" : "d-none"}>
        <div className="col-md-4">
            <div className="form-group">
                <div className="form-label">
                    Seu nome:
                </div>
                <FormControl />
            </div>
        </div>
        <div className="col-md-4">
            <div className="form-group">
                <div className="form-label">
                    Seu E-mail:
                </div>
                <FormControl />
            </div>
        </div>
        <div className="col-md-4">
            <div className="form-group">
                <div className="form-label">
                    Seu Telefone:
                </div>
                <FormControl />
            </div>
        </div>
        <div className="col-md-4">
            <div className="form-group">
                <div className="form-label">
                    Seu CPF:
                </div>
                <FormControl />
            </div>
        </div>
    </div>
}

export default Individual


// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Individual/index.jsx